interface PercentInputProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

/** Number input for a percentage, with a fixed `%` suffix — pairs with CurrencyInput for the
 * percentage/dollar payment fields, which stay in sync in both directions. */
export function PercentInput({ value, onChange, className = '' }: PercentInputProps) {
  return (
    <div className={`relative ${className}`}>
      <input
        type="number"
        min="0"
        max="100"
        step="0.01"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full rounded-md border border-gray-300 py-1.5 pl-3 pr-7 text-sm"
      />
      <span className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 text-sm text-gray-400">%</span>
    </div>
  );
}
